import {
    handle,
    loader,
    default as ProfessionalOverviewRoute,
} from '~/routes/_app.professional.$urlSegment._index';

/**
 * The Business Manager preview serves the same overview the public site does,
 * legacy or revamped, so it reuses the public route's loader, handle and
 * legacy/revamp switch rather than keeping a second copy in step. Only the
 * surrounding layout differs — see ProfessionalPagePreview.
 */
export { loader, handle };
export default ProfessionalOverviewRoute;
